import { useContext } from "react";
import { UploadSettlementContext } from "./UploadSettlementProvider";

export const useUploadSettlementContext = () => useContext(UploadSettlementContext);

export default useUploadSettlementContext;
